import React from 'react';
import { FaHammer } from 'react-icons/fa';
import './admin-dashboard.css';
import MiningControl from './MiningControl';
import Tokenomics from './Tokenomics';

export default function MiningAndTokenomics() {
  return (
    <section className="admin-overview" style={{padding:'0'}}>
      <div className="dashboard-header" style={{marginBottom:'2rem'}}>
        <div className="welcome-section">
          <h2 className="dashboard-title" style={{display:'flex',alignItems:'center',gap:8}}>
            <FaHammer style={{opacity:0.7}}/> Mining & Tokenomics
          </h2>
        </div>
      </div>
      <div className="main-stats-row" style={{display:'flex',gap:'2rem',flexWrap:'wrap'}}>
        <div style={{flex:'1 1 350px'}}><MiningControl /></div>
        <div style={{flex:'1 1 350px'}}><Tokenomics /></div>
      </div>
    </section>
  );
}
